// =============================================================================
// Admin Informativ API Calls
//
// Frontend utility for calling admin-protected Informativ routes on the backend.
// =============================================================================

import axios from "axios";
import { clientVitalsAPI } from "../secrets";

export interface RotateMasterPasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export interface RotateMasterPasswordResponse {
  success: boolean;
  message: string;
}

export const rotateMasterPassword = async (
  payload: RotateMasterPasswordPayload
): Promise<RotateMasterPasswordResponse> => {
  const result = await axios.post(
    `${clientVitalsAPI}/admin/informativ/rotate-master-password`,
    payload
  );
  return result.data;
};

